import { createSearchParams } from "react-router-dom";
import { NodeType, ViewMode, NodeTypeScopeRoutes } from "~/constants";
import { urlEncode } from "~/utils";

export const transformSingleUrlToListingPreviewRoute = (
  route: string,
  type: NodeType,
  listingViewMode: ViewMode
) => {
  return `/${NodeTypeScopeRoutes[type]}?${createSearchParams({
    focused: urlEncode(route),
    viewMode: urlEncode(listingViewMode),
  })}`;
};
